import React, { useEffect, useState } from 'react';
import '../Static/dashboard.css';
import { TextField, FormControl, InputLabel, Select, MenuItem, Grid } from '@mui/material';
import styled from '../Utils/inputChanges';
import { useNavigate } from 'react-router-dom';
import SOTracking from './TrackingTbl/SOTracking';


const DashboardPHP = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        textInput: '',
        dropdownInput: ''
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleDropdownChange = (e) => {
        const { value } = e.target;
        setFormData({
            ...formData,
            dropdownInput: value
        });
    };


    const item = [
        {
            icon: 'firm',
            title: 'Firm'
        },
        {
            icon: 'cloth',
            title: 'Cloth'
        },
        {
            icon: 'cut',
            title: 'Cutting'
        },
        {
            icon: 'items',
            title: ' Items'
        },
        {
            icon: 'kaja',
            title: 'Kaja'
        }
    ];

    useEffect(() => {
        const user = JSON.parse(sessionStorage.getItem('user'));
        const now = new Date();

        // If no user or session older than 1 hour, redirect
        if (!user) {
            sessionStorage.clear();
            navigate('/');
        }
    }, []);

    return (
        <>

            <div className="icon-container">
                {item.map((ele, index) => (
                    <div className="icon-card" key={index}>
                        <img alt="icon" src={`/assets/icons/${ele.icon}.png`} />
                        <div className="card-title">{ele.title}</div>
                    </div>
                ))}
            </div>


            <SOTracking />

        </>
    );
}

export default DashboardPHP;

